import styles from "@/components/layout/Navbar/Bookmarks/Bookmarks.module.css";
import { BookmarkListItem } from "@/components/layout/Navbar/Bookmarks/BookmarksListItem";
import { NavbarButton } from "@/components/layout/Navbar/NavbarButton";
import { RemoveBookmarkIcon } from "@/components/ui/Icons";
import { MenuList } from "@/components/ui/MenuList";
import { Popover } from "@/components/ui-deprecated/Popover";
import { usePopover } from "@/hooks/usePopover";
import { useAppSelector } from "@/store";

const Bookmarks = () => {
    const { ref, isOpen, handleToggleOpen, handleClose } = usePopover();
    const bookmarks = useAppSelector((state) => state.bookmark.bookmarks);

    const showNoData = bookmarks.length === 0;

    return (
        <div ref={ref} style={{ position: "relative" }}>
            <NavbarButton onClick={handleToggleOpen} title={"Bookmarks"}>
                <RemoveBookmarkIcon />
            </NavbarButton>
            {isOpen && (
                <Popover variant={"bottom"} style={{ right: 0 }}>
                    <MenuList className={styles.bookmarks_list}>
                        {showNoData && <div className={styles.bookmarks_info}>No bookmarks</div>}
                        {bookmarks.map((item, index) => {
                            return <BookmarkListItem key={index} item={item} onClick={handleClose} />;
                        })}
                    </MenuList>
                </Popover>
            )}
        </div>
    );
};

export { Bookmarks };
